import {
    Component,
    CUSTOM_ELEMENTS_SCHEMA,
    input,
    model,
    output,
} from '@angular/core';

/**
 * Campo para dados confidenciais (ex.: segredos/chaves), com opção de
 * mascarar/revelar o valor.
 *
 * NOTA: a implementação do template ainda é um placeholder; os inputs/outputs
 * abaixo definem a API pretendida. Os handlers repassam os eventos do campo.
 */
@Component({
    selector: 'ai-confidential',
    standalone: true,
    schemas: [CUSTOM_ELEMENTS_SCHEMA],
    templateUrl: './confidential-input.component.html',
})
export class ConfidentialInput {
    /** Rótulo do campo. */
    label = input<string>();
    /** Placeholder do campo. */
    placeholder = input<string>();
    /** Destaca visualmente o campo. */
    isHighlight = input<boolean>(false);
    /** Desabilita o campo. */
    disabled = input<boolean>(false);
    /** Texto do tooltip. */
    tooltipText = input<string>();
    /** Exibe o rótulo na mesma linha do campo. */
    labelInline = input<boolean>(false);
    /** Aplica foco automático ao campo. */
    autofocus = input<boolean>(false);
    /** Estado visual do campo. */
    state = input<string>();

    /** Emite no evento de `change` do campo. */
    change = output<any>();
    /** Emite ao clicar no ícone (revelar/ocultar). */
    iconClick = output<any>();
    /** Emite no evento de digitação. */
    keyUp = output<any>();

    /** Valor do campo (two-way via `model`). */
    value = model<string>();

    /** Repassa o evento de `change`. */
    handleOnChange(event: any): void {
        this.change.emit(event);
    }

    /** Atualiza {@link value} e repassa o evento de digitação. */
    handleOnInput(event: any): void {
        this.value.set(event.target.value);
        this.keyUp.emit(event);
    }

    /** Repassa o clique no ícone. */
    handleOnIconClicked(event: any): void {
        this.iconClick.emit(event);
    }
}
